import Box from '@mui/material/Box'
import Container from '@mui/material/Container'
import Stack from '@mui/material/Stack'
import { alpha, styled, useTheme } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
// import { Image } from '@repo/shared-core-ui-components/data-display/Image/Image'

// --------------------------------------------------------------------------------------------- //

const StyledRoot = styled('div')(({ theme }) => ({
  textAlign: 'center',
  padding: theme.spacing(2, 0),
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'top center',
  color: 'common.white',
  [theme.breakpoints.up('md')]: {
    padding: theme.spacing(2, 0)
  }
}))

// --------------------------------------------------------------------------------------------- //

const StyledGradientText = styled('h1')(({ theme }) => ({
  backgroundSize: '400%',
  textAlign: 'center',
  padding: 0,
  marginTop: 4,
  marginBottom: 24,
  // letterSpacing: -0.5,
  fontWeight: 800,
  lineHeight: 1.25,
  [theme.breakpoints.up('md')]: {
    fontSize: 62
  }
}))

export default function BacktestingFeatureHero() {
  const theme = useTheme()

  return (
    <StyledRoot>
      <Container>
        <Stack spacing={2} direction="row" alignItems="center" display="inline-flex">
          <StyledGradientText>Realistic, Meaningful Backtesting</StyledGradientText>
        </Stack>

        <Typography variant="h4" sx={{ color: 'grey.500' }}>
          Get an accurate and extensive report on how your tradingbot would have performed in the past
        </Typography>

        <Box
          sx={{
            my: { xs: 5, md: 10 },
            borderRadius: 2,
            boxShadow: `0px 0px 45px 5px ${alpha(theme.palette.common.white, 0.24)}`
          }}
        >
          <video
            src="https://res.cloudinary.com/dedhivftw/video/upload/v1729419297/website-assets/backtesting/iyjc0gxvsn3jr7hwpqcg.mp4"
            muted
            autoPlay
            loop
            playsInline
            disableRemotePlayback
            style={{ width: '100%', borderRadius: '16px', display: 'flex' }}
          />
        </Box>
      </Container>
    </StyledRoot>
  )
}
